<template lang='html'>
  <v-form ref="form" v-model='valid'>
    <div class="proxy-settings-input-container">
      <span v-if='!valid'>
        <v-alert
          text
          dense
          color="#e0255e"
          icon="info"
          border="left"
          class='not-valid-message'
        >
          {{ $t('proxy.not.valid.message') }}
        </v-alert>
      </span>
      <span class='proxy-settings-field address'>
        <div class='address__ip'>
          <span class='label'>{{ proxyAddressFieldTitle }}</span>
          <text-field
            :placeholder='proxyAddressFormatsPlaceholder'
            :rules='[rules.required, proxyAddressRule]'
            v-model='internalValue.proxySettings.address.ip'
          />
        </div>
        <div class='address__port'>
          <span class='label'>{{ proxyAddressPortFieldTitle }}</span>
          <text-field
            :placeholder='proxyAddressPortFieldTitle'
            :rules='[portsRules]'
            v-model='internalValue.proxySettings.address.port'
          />
        </div>
      </span>
      <custom-checkbox v-model="internalValue.authentication.useAuthentication" size="s" :title="$t('test.usePredefinedCredentials')" color="cold-marine" />
      <div class='select-authentication-object' v-if='internalValue.authentication.useAuthentication'>
        <select-authentication-object v-model='internalValue.authentication' :type='authenticationType'  @updateValid='updateValid'/>
      </div>
      <div class='fill-manual-authentication' v-else>
        <span class='proxy-settings-field'>
          <span class='label'>{{ proxyUsernameFieldTitle }}</span>
          <text-field
            :placeholder='proxyUsernameFieldTitle'
            v-model='internalValue.proxySettings.credentials.userName'
          />
        </span>
        <span class='proxy-settings-field'>
          <span class='label'>{{ proxyPasswordFieldTitle }}</span>
          <text-field
            :placeholder='proxyPasswordFieldTitle'
            v-model='internalValue.proxySettings.credentials.password'
          />
        </span>
      </div>
    </div>
  </v-form>
</template>

<script>
import TextField from '@/components/common/TextField.vue';
import { rules } from '@/utils/validationUtils';
import { TEST_TYPES_HOSTS } from '@/constants/projects';
import CustomCheckbox from '@/components/common/CustomCheckbox.vue';
import SelectAuthenticationObject from '@/components/common/SelectAuthenticationObject.vue';
import { AUTHENTICATION_OBJECT_TYPES } from '@/constants/authenticationObject';

export default {
  name: 'ProxySettingsInput',
  components: { TextField, CustomCheckbox, SelectAuthenticationObject },
  props: {
    value: Object,
    type: {
      required: true,
    },
  },
  data() {
    return {
      valid: false,
    };
  },
  watch: {
    valid() {
      this.updateValid();
    },
  },
  methods: {
    updateValid() {
      this.$emit('updateValid', this.valid);
    },
  },
  computed: {
    authenticationType() {
      return AUTHENTICATION_OBJECT_TYPES.USER_PASSWORD;
    },
    rules() {
      return rules;
    },
    portsRules() {
      return v => ((!!v && rules.required(v) && rules.port(v)) || this.type === TEST_TYPES_HOSTS.deepscan);
    },
    proxyAddressRule() {
      return v => (!!v && (rules.host(v) || rules.fqdn(v)));
    },
    proxyAddressFieldTitle() {
      return this.$t('test.proxy.settings.address.title');
    },
    proxyAddressPortFieldTitle() {
      return this.$t('test.proxy.settings.address.port.title');
    },
    proxyPasswordFieldTitle() {
      return this.$t('test.proxy.settings.password.title');
    },
    proxyUsernameFieldTitle() {
      return this.$t('test.proxy.settings.username.title');
    },
    proxyAddressFormatsPlaceholder() {
      return this.$t('test.proxy.settings.address.format');
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.proxy-settings-input-container {
  .v-input {
    margin-top: rem(3);
  }
  .v-input__slot {
    min-height: rem(28);
  }
  .v-alert__icon.v-icon {
    color: $severity-critical;
  }
}
</style>
<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.proxy-settings-input-container {
  .not-valid-message {
    font-size: $font-size-xs;
    font-weight: 600;
    letter-spacing: rem(1.12);
    line-height: $space-4;
  }
  .address {
    margin-top: $space-4;
    display: flex;
    &__ip {
      min-width: rem(220);
      display: flex;
      flex-direction: column;
      flex:2;
    }
    &__port {
      margin-left: rem(3);
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
  .label {
    text-transform: uppercase;
    color: var(--input-label);
    font-family: $font-family-regular;
    font-size: rem(9);
    letter-spacing: rem(0.8);
    line-height: rem(10);
  }
  .proxy-settings-field {
    margin-bottom: $space-2;
  }
  margin-top: $space-2;
  margin-bottom: $space-5;
}
</style>
